import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

// Auth Pages
import AdminLogin from "@/pages/AdminLogin";
import WorkerLogin from "@/pages/WorkerLogin";

// Super Admin Pages
import SuperAdminDashboard from "@/pages/SuperAdmin/Dashboard";
import ClientManagement from "@/pages/SuperAdmin/ClientManagement";

// Client Admin Pages
import ClientAdminDashboard from "@/pages/ClientAdmin/Dashboard";
import WorkerManagement from "@/pages/ClientAdmin/WorkerManagement";
import CourseManagement from "@/pages/ClientAdmin/CourseManagement";
import Analytics from "@/pages/ClientAdmin/Analytics";
import Settings from "@/pages/ClientAdmin/Settings";
import OperationsSuite from "@/pages/ClientAdmin/OperationsSuite";

// Worker Pages
import WorkerDashboard from "@/pages/Worker/Dashboard";
import VideoPlayer from "@/pages/Worker/VideoPlayer";
import Quiz from "@/pages/Worker/Quiz";
import Certificates from "@/pages/Worker/Certificates";
import Profile from "@/pages/Worker/Profile";

// Protected Route Component
const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/admin/login" replace />} />
          
          {/* Auth Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/worker/login" element={<WorkerLogin />} />
          
          {/* Super Admin Routes */}
          <Route
            path="/super-admin/dashboard"
            element={
              <ProtectedRoute allowedRoles={["super_admin"]}>
                <SuperAdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/clients"
            element={
              <ProtectedRoute allowedRoles={["super_admin"]}>
                <ClientManagement />
              </ProtectedRoute>
            }
          />
          
          {/* Client Admin Routes */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute allowedRoles={["client_admin"]}>
                <ClientAdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/workers"
            element={
              <ProtectedRoute allowedRoles={["client_admin"]}>
                <WorkerManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/courses"
            element={
              <ProtectedRoute allowedRoles={["client_admin"]}>
                <CourseManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/analytics"
            element={
              <ProtectedRoute allowedRoles={["client_admin"]}>
                <Analytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <ProtectedRoute allowedRoles={["client_admin"]}>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/operations"
            element={
              <ProtectedRoute allowedRoles={["client_admin"]}>
                <OperationsSuite />
              </ProtectedRoute>
            }
          />
          
          {/* Worker Routes */}
          <Route
            path="/worker/dashboard"
            element={
              <ProtectedRoute allowedRoles={["worker"]}>
                <WorkerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/worker/course/:courseId"
            element={
              <ProtectedRoute allowedRoles={["worker"]}>
                <VideoPlayer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz/:courseId/:moduleIndex"
            element={
              <ProtectedRoute allowedRoles={["worker"]}>
                <Quiz />
              </ProtectedRoute>
            }
          />
          <Route
            path="/worker/certificates"
            element={
              <ProtectedRoute allowedRoles={["worker"]}>
                <Certificates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/worker/profile"
            element={
              <ProtectedRoute allowedRoles={["worker"]}>
                <Profile />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
